(function () {
  document.querySelectorAll('.custom-cake').forEach(initCustomCake);

  function initCustomCake(root) {
    const cakeTypeRadios = root.querySelectorAll('[data-cake-type-radio]');
    const config = document.querySelector('[data-custom-cake-config]');
    const form = root.querySelector('.custom-cake__form');
    const depositVariantId = config ? config.dataset.depositVariantId : null;

    // Lead time counts Monday to Friday only: Saturday is a pickup day, not a
    // production day (Regulamin § 2). Sunday is the one day nothing can be
    // collected either. The number of days is editable per section in the
    // theme customizer (min_business_days).
    const CLOSED_WEEKDAY = 0;

    function isBusinessDay(date) {
      const day = date.getDay();
      return day !== 0 && day !== 6;
    }

    function toDateInputValue(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return year + '-' + month + '-' + day;
    }

    function earliestPickupDate() {
      const parsedDays = config ? parseInt(config.dataset.minBusinessDays, 10) : NaN;
      const businessDays = isNaN(parsedDays) ? 1 : parsedDays;
      const date = new Date();
      date.setHours(0, 0, 0, 0);
      let added = 0;
      while (added < businessDays) {
        date.setDate(date.getDate() + 1);
        if (isBusinessDay(date)) added++;
      }
      return date;
    }

    const dateInput = root.querySelector('[data-cake-date-input]');
    const dateError = root.querySelector('[data-cake-date-error]');

    const CLOSED_MESSAGE = dateError ? dateError.textContent.trim() : '';

    // The minimum used to be enforced by the input's "min" attribute alone.
    // Chrome and Firefox refuse to submit a form whose date falls below it, so
    // the lead time held; Safari submits anyway and the cake could be ordered
    // for the same day. The rule is therefore checked here too, and the
    // attribute is left in place only to grey the earlier days out.
    function pickupDateIssue() {
      if (!dateInput || !dateInput.value) return null;
      const [year, month, day] = dateInput.value.split('-').map(Number);
      const selected = new Date(year, month - 1, day);
      if (isNaN(selected.getTime())) return 'Wybierz poprawną datę odbioru.';
      if (selected.getDay() === CLOSED_WEEKDAY) return CLOSED_MESSAGE;
      const earliest = earliestPickupDate();
      if (selected < earliest) {
        return 'Najwcześniejszy możliwy termin odbioru to ' + earliest.toLocaleDateString('pl-PL') + '.';
      }
      return null;
    }

    function showDateIssue(message) {
      if (!dateError) return;
      dateError.textContent = message || CLOSED_MESSAGE;
      dateError.hidden = !message;
    }

    if (dateInput) {
      dateInput.min = toDateInputValue(earliestPickupDate());
      dateInput.addEventListener('change', () => {
        if (!dateInput.value) {
          showDateIssue(null);
          return;
        }
        const issue = pickupDateIssue();
        // A Sunday is cleared, as it always was; a date that is merely too
        // early keeps its value while the customer corrects it.
        if (issue === CLOSED_MESSAGE) dateInput.value = '';
        showDateIssue(issue);
      });
    }

    const mainImage = root.querySelector('[data-cake-main-image]');
    const mainPlaceholder = root.querySelector('[data-cake-main-placeholder]');
    const flavorImage = root.querySelector('[data-cake-flavor-image]');
    const flavorSlide = root.querySelector('[data-cake-flavor-slide]');
    const gallerySlider = root.querySelector('.custom-cake__gallery-slider');

    // Tooltips (info icons + pattern swatches) are centered on their trigger
    // by default. When the trigger sits close to the edge of the page, the
    // tooltip can extend past the viewport — even while hidden (opacity: 0
    // still occupies layout space), which inflates the page's real scrollable
    // width. Nudge each tooltip back into view right before it's shown,
    // measuring against the viewport itself so this holds regardless of the
    // browser engine's own overflow/layout quirks.
    function wireTooltipReposition(trigger, tooltip, events) {
      if (!tooltip) return;
      const reposition = () => {
        tooltip.style.marginLeft = '';
        const margin = 8;
        const tooltipRect = tooltip.getBoundingClientRect();
        let shift = 0;
        const viewportWidth = document.documentElement.clientWidth;
        if (tooltipRect.left < margin) {
          shift = margin - tooltipRect.left;
        } else if (tooltipRect.right > viewportWidth - margin) {
          shift = viewportWidth - margin - tooltipRect.right;
        }
        if (shift !== 0) {
          tooltip.style.marginLeft = shift + 'px';
        }
      };
      // Run once immediately: even hidden (opacity: 0), a tooltip still
      // occupies layout space, so an unshifted one near the edge would
      // inflate the page's real scrollable width from the moment it loads.
      reposition();
      events.forEach((eventName) => trigger.addEventListener(eventName, reposition));
      // Re-check whenever the tooltip's own box actually changes size — e.g.
      // once web fonts finish loading and its max-content text re-measures,
      // which happens after our initial synchronous call above.
      if (window.ResizeObserver) {
        new ResizeObserver(reposition).observe(tooltip);
      }
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(reposition);
      }
      window.addEventListener('resize', reposition);
    }

    root.querySelectorAll('.custom-cake__info-icon').forEach((icon) => {
      wireTooltipReposition(icon, icon.querySelector('.custom-cake__tooltip--info'), ['mouseenter', 'focus']);
    });

    root.querySelectorAll('.custom-cake__pattern').forEach((pattern) => {
      wireTooltipReposition(pattern, pattern.querySelector('.custom-cake__tooltip--pattern'), ['mouseenter']);
    });

    function updateSelectedPattern(radio) {
      if (mainImage && radio.dataset.patternImageSrc) {
        mainImage.src = radio.dataset.patternImageSrc;
        mainImage.hidden = false;
        if (mainPlaceholder) mainPlaceholder.hidden = true;
      }
    }

    function updateSelectedFlavor(radio) {
      const hasImage = !!(flavorImage && radio.dataset.flavorImageSrc);
      if (flavorImage && hasImage) {
        flavorImage.src = radio.dataset.flavorImageSrc;
      }
      // The slide (not just the image) is hidden/shown, so the gallery
      // slider's own slide count — and its "1 / 2" counter — stays accurate.
      if (flavorSlide) {
        const wasHidden = flavorSlide.hidden;
        flavorSlide.hidden = !hasImage;
        if (wasHidden !== flavorSlide.hidden && gallerySlider && typeof gallerySlider.resetPages === 'function') {
          gallerySlider.resetPages();
        }
      }
    }

    let hasPatternsForCurrentType = false;
    let allowsInspirationForCurrentType = true;

    function updateDesignSections() {
      const designToggle = root.querySelector('[data-design-toggle]');
      const patternsWrap = root.querySelector('[data-patterns-wrap]');
      const inspirationField = root.querySelector('[data-inspiration-upload]');

      if (!hasPatternsForCurrentType) {
        if (designToggle) designToggle.hidden = true;
        if (patternsWrap) patternsWrap.hidden = true;
        if (inspirationField) inspirationField.hidden = false;
        return;
      }

      if (!allowsInspirationForCurrentType) {
        if (designToggle) designToggle.hidden = true;
        if (patternsWrap) patternsWrap.hidden = false;
        if (inspirationField) inspirationField.hidden = true;
        return;
      }

      if (designToggle) designToggle.hidden = false;
      const checkedMode = root.querySelector('[data-design-mode-radio]:checked');
      const mode = checkedMode ? checkedMode.dataset.designMode : 'pattern';
      if (patternsWrap) patternsWrap.hidden = mode !== 'pattern';
      if (inspirationField) inspirationField.hidden = mode !== 'inspiration';
    }

    function showCakeType(key) {
      root.querySelectorAll('[data-cake-type-detail]').forEach((el) => {
        el.hidden = el.dataset.cakeTypeDetail !== key;
      });
      root.querySelectorAll('[data-cake-type-price]').forEach((el) => {
        el.hidden = el.dataset.cakeTypePrice !== key;
      });
      const activeCakeTypeRadio = root.querySelector('[data-cake-type-radio][data-cake-type-key="' + key + '"]');
      allowsInspirationForCurrentType = !activeCakeTypeRadio || activeCakeTypeRadio.dataset.allowsInspiration !== 'false';
      let hasVisiblePatterns = false;
      root.querySelectorAll('[data-cake-type-patterns]').forEach((el) => {
        const isVisible = el.dataset.cakeTypePatterns === key;
        el.hidden = !isVisible;
        if (isVisible) {
          hasVisiblePatterns = true;
          let checkedRadio = el.querySelector('[data-pattern-radio]:checked');
          if (!checkedRadio) {
            checkedRadio = el.querySelector('[data-pattern-radio]');
            if (checkedRadio) checkedRadio.checked = true;
          }
          if (checkedRadio) updateSelectedPattern(checkedRadio);
        }
      });
      hasPatternsForCurrentType = hasVisiblePatterns;
      updateDesignSections();
      root.querySelectorAll('[data-cake-type-flavors]').forEach((el) => {
        const isVisible = el.dataset.cakeTypeFlavors === key;
        el.hidden = !isVisible;
        if (isVisible) {
          let checkedRadio = el.querySelector('[data-flavor-radio]:checked');
          if (!checkedRadio) {
            checkedRadio = el.querySelector('[data-flavor-radio]');
            if (checkedRadio) checkedRadio.checked = true;
          }
          if (checkedRadio) updateSelectedFlavor(checkedRadio);
        }
      });
    }

    cakeTypeRadios.forEach((radio) => {
      radio.addEventListener('change', () => {
        if (radio.checked) showCakeType(radio.dataset.cakeTypeKey);
      });
    });

    const initialChecked = root.querySelector('[data-cake-type-radio]:checked');
    if (initialChecked) showCakeType(initialChecked.dataset.cakeTypeKey);

    root.querySelectorAll('[data-pattern-radio]').forEach((radio) => {
      radio.addEventListener('change', () => {
        if (radio.checked) updateSelectedPattern(radio);
      });
    });

    root.querySelectorAll('[data-flavor-radio]').forEach((radio) => {
      radio.addEventListener('change', () => {
        if (radio.checked) updateSelectedFlavor(radio);
      });
    });

    root.querySelectorAll('[data-design-mode-radio]').forEach((radio) => {
      radio.addEventListener('change', () => {
        if (radio.checked) updateDesignSections();
      });
    });

    const fileInput = root.querySelector('[data-file-input]');
    const fileClear = root.querySelector('[data-file-input-clear]');

    if (fileInput && fileClear) {
      fileInput.addEventListener('change', () => {
        fileClear.hidden = fileInput.files.length === 0;
      });
      fileClear.addEventListener('click', () => {
        fileInput.value = '';
        fileClear.hidden = true;
      });
    }

    const portionsValueInput = root.querySelector('[data-portions-value]');
    const customPortionsWrap = root.querySelector('[data-custom-portions]');
    const customPortionsValue = root.querySelector('[data-custom-portions-value]');
    const customPortionsDecrease = root.querySelector('[data-custom-portions-decrease]');
    const customPortionsIncrease = root.querySelector('[data-custom-portions-increase]');
    const bentoNotice = root.querySelector('[data-bento-notice]');
    const bentoValueInput = root.querySelector('[data-bento-value]');
    const portionSelect = root.querySelector('[data-portion-select]');
    const CUSTOM_PORTIONS_MIN = 36;

    function updatePortionsValue() {
      if (!portionsValueInput) return;
      const checkedPortion = portionSelect && portionSelect.selectedOptions[0];
      if (!checkedPortion) return;
      if (checkedPortion.hasAttribute('data-portion-custom')) {
        const count = customPortionsValue ? customPortionsValue.textContent : CUSTOM_PORTIONS_MIN;
        portionsValueInput.value = count + ' porcji (niestandardowa ilość, wycena indywidualna)';
      } else {
        portionsValueInput.value = checkedPortion.dataset.portionLabel;
      }

      const bentoRequired = checkedPortion.hasAttribute('data-portion-bento-required');
      if (bentoNotice) bentoNotice.hidden = !bentoRequired;
      if (bentoValueInput) bentoValueInput.value = bentoRequired ? 'Tak (+15 zł, obowiązkowe przy 6 porcjach)' : '';
    }

    // The last option ("Niestandardowa ilość porcji") reveals the stepper.
    function applyPortionChoice() {
      const choice = portionSelect && portionSelect.selectedOptions[0];
      if (customPortionsWrap) customPortionsWrap.hidden = !(choice && choice.hasAttribute('data-portion-custom'));
      updatePortionsValue();
    }

    if (portionSelect) portionSelect.addEventListener('change', applyPortionChoice);
    applyPortionChoice();

    function updateCustomPortionsButtonState() {
      if (!customPortionsValue || !customPortionsDecrease) return;
      customPortionsDecrease.disabled = parseInt(customPortionsValue.textContent, 10) <= CUSTOM_PORTIONS_MIN;
    }

    if (customPortionsValue && customPortionsDecrease && customPortionsIncrease) {
      updateCustomPortionsButtonState();
      customPortionsDecrease.addEventListener('click', () => {
        const next = Math.max(CUSTOM_PORTIONS_MIN, parseInt(customPortionsValue.textContent, 10) - 1);
        customPortionsValue.textContent = next;
        updateCustomPortionsButtonState();
        updatePortionsValue();
      });
      customPortionsIncrease.addEventListener('click', () => {
        const next = Math.max(CUSTOM_PORTIONS_MIN, parseInt(customPortionsValue.textContent, 10) + 1);
        customPortionsValue.textContent = next;
        updateCustomPortionsButtonState();
        updatePortionsValue();
      });
    }

    // Ozdoby are collected into one hidden field: Shopify's contact endpoint
    // rejects repeated contact[Ozdoby][] values and fails the whole submission.
    const addonsValue = root.querySelector('[data-cake-addons-value]');
    const addonBoxes = root.querySelectorAll('[data-cake-addon]');
    if (addonsValue && addonBoxes.length) {
      const syncAddons = () => {
        const picked = [];
        addonBoxes.forEach((box) => {
          if (box.checked) picked.push(box.value);
        });
        addonsValue.value = picked.join(', ');
      };
      addonBoxes.forEach((box) => box.addEventListener('change', syncAddons));
      syncAddons();
    }

    if (!form) return;
    if (!depositVariantId) return;

    const successBox = root.querySelector('[data-cake-success]');
    const errorBox = root.querySelector('[data-cake-error]');
    const errorText = root.querySelector('[data-cake-error-text]');
    const submitButton = root.querySelector('[data-custom-cake-submit]');
    const submitLabel = submitButton ? submitButton.querySelector('span') : null;
    const submitLabelIdle = submitLabel ? submitLabel.textContent : '';

    // Longest edge of the uploaded inspiration photo. Oliwia looks at these on a
    // laptop, not a lightbox: 1600px keeps the detail that matters and turns a
    // 5 MB phone photo into a few hundred kilobytes, which is what makes the
    // round trip to Apps Script finish while the customer is still watching.
    const PHOTO_MAX_EDGE = 1600;
    const PHOTO_QUALITY = 0.82;

    /**
     * The submission reference. Generated here rather than printed by Liquid:
     * a value rendered server-side would be baked into Shopify's full-page
     * cache and handed to every visitor, so two orders would share one number.
     *
     * The ZG- prefix distinguishes an enquiry number from a Shopify order
     * number, which starts with OP-. This is a second copy of reference() in
     * form-to-sheets.js — change both or the pairing breaks silently.
     */
    function makeReference() {
      const now = new Date();
      const day =
        String(now.getFullYear()) +
        String(now.getMonth() + 1).padStart(2, '0') +
        String(now.getDate()).padStart(2, '0');
      let tail = '';
      while (tail.length < 4) tail += Math.random().toString(36).slice(2).toUpperCase();
      return 'ZG-' + day + '-' + tail.replace(/[^A-Z0-9]/g, '').slice(0, 4);
    }

    function ensureReference() {
      const field = form.querySelector('[data-sheets-ref]');
      if (!field) return '';
      if (!field.value) field.value = makeReference();
      return field.value;
    }

    /** Draws the photo onto a canvas at a sane size and re-encodes it as JPEG. */
    function shrinkPhoto(file) {
      return createImageBitmap(file, { imageOrientation: 'from-image' }).then((bitmap) => {
        const scale = Math.min(1, PHOTO_MAX_EDGE / Math.max(bitmap.width, bitmap.height));
        const canvas = document.createElement('canvas');
        canvas.width = Math.round(bitmap.width * scale);
        canvas.height = Math.round(bitmap.height * scale);
        canvas.getContext('2d').drawImage(bitmap, 0, 0, canvas.width, canvas.height);
        if (bitmap.close) bitmap.close();
        return new Promise((resolve, reject) => {
          canvas.toBlob(
            (blob) => (blob ? resolve(blob) : reject(new Error('nie udało się przygotować zdjęcia'))),
            'image/jpeg',
            PHOTO_QUALITY
          );
        });
      });
    }

    function toBase64(blob) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(String(reader.result).split(',')[1]);
        reader.onerror = () => reject(new Error('nie udało się odczytać pliku'));
        reader.readAsDataURL(blob);
      });
    }

    /**
     * Sends the photo to the Apps Script and returns the Drive link that goes
     * onto the order as a hidden line-item property.
     *
     * The content type has to be text/plain even though the body is JSON:
     * application/json would make the browser send a CORS preflight, and an
     * Apps Script web app cannot answer OPTIONS, so the request would fail
     * before it ever reached the script.
     */
    function uploadPhoto(file, reference) {
      const endpoint = form.dataset.cakeEndpoint;
      if (!endpoint) return Promise.resolve('');

      return shrinkPhoto(file)
        .then(toBase64)
        .then((data) =>
          fetch(endpoint, {
            method: 'POST',
            headers: { 'Content-Type': 'text/plain;charset=utf-8' },
            body: JSON.stringify({
              action: 'photo',
              reference: reference,
              filename: file.name,
              mime: 'image/jpeg',
              data: data,
            }),
          })
        )
        .then((response) => response.json())
        .then((result) => {
          if (!result || !result.ok || !result.url) {
            throw new Error((result && result.error) || 'zapis zdjęcia nie powiódł się');
          }
          return result.url;
        });
    }

    // Name and e-mail are collected by the checkout anyway, and the order is
    // where the team reads them from; repeating them on the line would only
    // put the same person on the screen twice.
    // "Formularz" was routing metadata for the old sheet copy; since the row is
    // now written from the order, nothing reads it and it would only show up in
    // the cart as a line the customer cannot make sense of.
    const SKIP_PROPERTIES = { 'Imię': true, 'Nazwisko': true, email: true, Formularz: true };
    // A leading underscore keeps a property off the cart and checkout display
    // while still carrying it onto the order.
    const HIDDEN_PROPERTIES = { 'Telefon': '_Telefon' };

    /**
     * Which of the two design routes the customer is on. The pattern radios and
     * the upload field both keep their state when the toggle flips, so without
     * this the order would carry a chosen pattern next to "I am sending my own
     * inspiration" — a specification that contradicts itself, which is exactly
     * what the team would have to ring the customer about.
     */
    function usesOwnInspiration() {
      const checked = root.querySelector('[data-design-mode-radio]:checked');
      return !!checked && /inspiracj/i.test(checked.value);
    }

    function collectProperties(reference, photoUrl) {
      const properties = {};

      Array.prototype.forEach.call(form.elements, (element) => {
        if (!element.name || element.disabled || element.type === 'file') return;
        const match = element.name.match(/^contact\[(.+?)\]$/);
        if (!match) return;

        const field = match[1];
        if (SKIP_PROPERTIES[field]) return;
        if ((element.type === 'checkbox' || element.type === 'radio') && !element.checked) return;

        const value = String(element.value).trim();
        if (!value) return;
        properties[HIDDEN_PROPERTIES[field] || field] = value;
      });

      properties['Nr zgłoszenia'] = reference;
      if (usesOwnInspiration()) {
        delete properties['Wybrany wzór'];
        if (photoUrl) properties['_Zdjęcie inspiracji'] = photoUrl;
      }
      return properties;
    }

    function setBusy(state) {
      if (submitButton) {
        submitButton.disabled = state;
        submitButton.setAttribute('aria-busy', state ? 'true' : 'false');
      }
      if (submitLabel) submitLabel.textContent = state ? 'Wysyłanie…' : submitLabelIdle;
    }

    function showError(message) {
      if (!errorBox) return;
      if (errorText) errorText.textContent = message;
      errorBox.hidden = false;
      errorBox.focus();
    }

    let busy = false;

    /**
     * Nothing is sent anywhere until the customer pays: the whole specification
     * rides to the order as line-item properties, and the sheet row is written
     * later by the "order paid" webhook. The only thing that leaves the browser
     * here is the photo, because this is the one moment the file is in hand.
     */
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      if (busy) return;

      const dateIssue = pickupDateIssue();
      if (dateIssue) {
        showError(dateIssue);
        showDateIssue(dateIssue);
        if (dateInput) dateInput.focus();
        return;
      }

      busy = true;
      setBusy(true);
      if (errorBox) errorBox.hidden = true;

      const reference = ensureReference();
      const file = usesOwnInspiration() && fileInput && fileInput.files && fileInput.files[0];
      // Saving to Drive takes about seven seconds, almost all of it Apps Script
      // starting up, so the wait gets its own wording rather than leaving the
      // customer wondering whether the button worked.
      if (file && submitLabel) submitLabel.textContent = 'Wysyłanie zdjęcia…';
      const photo = file ? uploadPhoto(file, reference) : Promise.resolve('');

      photo
        .then((photoUrl) =>
          fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: [
                {
                  id: Number(depositVariantId),
                  quantity: 1,
                  properties: collectProperties(reference, photoUrl),
                },
              ],
            }),
          })
        )
        .then((response) => {
          if (!response.ok) throw new Error('nie udało się dodać opłaty do koszyka');
          if (successBox) {
            successBox.hidden = false;
            successBox.focus();
          }
          // Long enough to read what happened, short enough not to feel stuck.
          setTimeout(() => {
            window.location.href = window.Shopify.routes.root + 'cart';
          }, 1500);
        })
        .catch((error) => {
          busy = false;
          setBusy(false);
          showError(
            file && String(error.message).indexOf('koszyk') === -1
              ? 'Nie udało się wysłać zdjęcia inspiracji. Spróbuj ponownie albo usuń zdjęcie i wyślij zgłoszenie bez niego.'
              : 'Nie udało się wysłać zgłoszenia. Odśwież stronę i spróbuj ponownie.'
          );
        });
    });
  }
})();
